/**
 * Configuración de Cal.com según el entorno
 * Dev: estudioprueba/asesoria-juridica
 * Prod: hyaabogados/reuncion-invercol
 */

// Detectar entorno: producción tiene prioridad si NODE_ENV es 'production'
// En build (npm run build), NODE_ENV siempre es 'production'
const isDevelopment =
  process.env.NODE_ENV !== 'production' &&
  (process.env.REACT_APP_ENV === 'development' || !process.env.REACT_APP_ENV);

const calConfig = {
  development: {
    namespace: 'asesoria-juridica',
    calLink: 'estudioprueba/asesoria-juridica',
  },
  production: {
    namespace: 'reuncion-invercol',
    calLink: 'hyaabogados/reuncion-invercol',
  },
};

const currentConfig = isDevelopment
  ? calConfig.development
  : calConfig.production;

// Log para debugging (solo en desarrollo)
if (process.env.NODE_ENV === 'development') {
  console.log('Cal.com Config:', {
    NODE_ENV: process.env.NODE_ENV,
    REACT_APP_ENV: process.env.REACT_APP_ENV,
    isDevelopment,
    config: currentConfig,
  });
}

export default currentConfig;
